import { graphql } from "@cappelendamm/crystallize-types/subscriptions/gql";
const request = (client, lastNode, customerIdentifier) => {
    return client.subscriptions.request(graphql(`
      query GetSubscriptionContracts(
        $tenantId: ID!
        $after: String
        $customerIdentifier: String
      ) {
        subscriptionContracts {
          getMany(
            tenantId: $tenantId
            after: $after
            customerIdentifier: $customerIdentifier
          ) {
            edges {
              node {
                id
                customerIdentifier
                item {
                  name
                  sku
                }
                status {
                  activeUntil
                  renewAt
                }
                meta {
                  key
                  value
                }
                subscriptionPlan {
                  identifier
                }
                createdAt
                updatedAt
              }
            }
            pageInfo {
              hasPreviousPage
              hasNextPage
              startCursor
              endCursor
              totalNodes
            }
          }
        }
      }
    `), {
        tenantId: client.tenantId,
        customerIdentifier: customerIdentifier,
        after: lastNode,
    });
};
export const getAllSubscriptionContracts = async ({ client }, customerIdentifier = "") => {
    const edges = [];
    let hasNextPage = true;
    let startCursor = "";
    while (hasNextPage) {
        const queryResult = await request(client, startCursor, customerIdentifier);
        const getManyContent = queryResult?.subscriptionContracts?.getMany;
        const content = getManyContent?.edges ?? [];
        edges.push(...content);
        hasNextPage = getManyContent?.pageInfo?.hasNextPage ?? false;
        startCursor = getManyContent?.pageInfo?.endCursor ?? "";
    }
    return edges.map((edge) => edge.node);
};
